// Version : 0.0.1
// Author : VISHAL BHARATHI
// LastEdit : VISHAL BHARATHI
// Last ADD : EXCEL PART REMOVED
// MODFIED DATA : 27-09-2025

const ReceiptsPaymentsActionTypes = {
	/** ***************** GET RECEIPTS PAYMENTS START *********************** */
	GET_RECEIPTS_PAYMENTS_LIST_START: 'get_receipts_payments_start',
	GET_RECEIPTS_PAYMENTS_LIST_SUCCESS: 'get_receipts_payments_success',
	GET_RECEIPTS_PAYMENTS_LIST_FAILURE: 'get_receipts_payments_failure',
	GET_RECEIPTS_PAYMENTS_LIST_RESPONSE_RESET: 'get_receipts_payments_response_reset',
	GET_RECEIPTS_PAYMENTS_LIST_RESPONSE_CHANGED: 'get_receipts_payments_response_changed',
	/** ***************** GET RECEIPTS PAYMENTS END *********************** */
};
export default ReceiptsPaymentsActionTypes;
